import isBrowser from "./isBrowser";

const gaEvent = (eventCategory, eventAction, eventLabel, eventValue) => {
  if(isBrowser()) {

    if(window.ga) {
      const ga = window.ga;
      ga("send", {
        "hitType": "event",
        "eventAction": eventAction,
        "eventCategory": eventCategory,
        "eventLabel": eventLabel
      });
    }
  }

  console.warn("Events that were sent: ", eventCategory, eventAction, eventLabel, eventValue);
};

export default gaEvent;
